import React, { Component, Fragment } from "reactn";
import Api from "js/core/api";
import {
    UIPane,
    UIPaneContents,
    Section,
    UIPaneHeader,
    BlueButton,
} from "js/react/components/UiComponents";
import Loadable from "js/react/components/Loadable";
import Avatar, { UserProfile } from "js/react/components/Avatar";
import moment from "moment";
import { RedSwitch } from "js/react/components/Switch";
import { SlideThumbnail } from "js/react/views/AddSlide/Panes/Components/ThumbnailGrid.js";
import { DialogTitle, DialogActions, Button, Icon, TextField, Chip } from "@material-ui/core";
import log from "js/core/logger";
import { ds } from "js/core/models/dataService";
import {
    ShowDialog,
    ShowErrorDialog,
    BeautifulDialog,
    DialogContent,
    ShowMessageDialog,
    ShowConfirmationDialog, ShowDialogAsync
} from "js/react/components/Dialogs/BaseDialog";
import ConfirmationCheckboxDialog from "js/react/components/Dialogs/ConfirmationCheckboxDialog";
import AddLibraryTagsDialog from "js/react/views/UserOptions/dialogs/AddLibraryTagsDialog";
import { LibraryItem } from "js/core/models/libraryItem";
import { caseInsensitiveSort, trackActivity } from "js/core/utilities/utilities";
import { FlexBox, ScrollBox } from "js/react/components/LayoutGrid";
import { Gap10, Gap20, Gap30 } from "js/react/components/Gap";
import getUserProfile from "js/core/services/userProfiles";
import styled from "styled-components";
import { PresentationLibraryList } from "js/editor/PresentationLibrary/PresentationLibraryList";
import { themeColors } from "js/react/sharedStyles";
import { $, _ } from "js/vendor";
import { TEAM_USER_ROLES } from "common/constants";
import { Presentation } from "js/core/models/presentation";
import { Slide } from "js/core/models/slide";
import { app } from "js/namespaces";
import { EditorView } from "js/editor/editor";
import Thumbnails from "js/core/models/thumbnails";
import AddSlideContainer from "js/react/views/AddSlide/AddSlideContainer";
import { CreateSharedSlideDialog } from "js/react/views/UserOptions/dialogs/CreateSharedSlideDialog";
import { UndoRedo } from "js/editor/undoRedo";

const SlideThumbnailContainer = styled.div`
    width: 640px;
    height: 360px;
    position: relative;
    
    .edit-message {
        opacity: 0;
        position: absolute;
        top: 0px;
        left: 0px;
        width: 100%;
        height: 100%;
        display: flex;
        align-items:  center;
        justify-content: center;
        padding: 50px;
        div {
          color: white;
          font-size: 18px;
          font-weight: 600;
          padding: 15px 20px;
          background: ${themeColors.ui_blue};
          text-align: center;
        }
    }
    &:hover {
      .edit-message {
        opacity: 1;
      }
    }
`;

const StatsContainer = styled.div`
  background: #f1f1f1;   
  width: 100%;
  padding: 15px;
  font-weight: 600;
  .MuiIcon-root {
    margin-right: 10px;
  }
  & > div + div {
    margin-top: 10px;
  }
`;
const UserInfo = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  label {
    font-size: 13px;
    width: 80px;
  }
  .avatar {
    margin-right: 10px;
  }
  .name {
    font-size: 14px;
    font-weight: 600;
    color: #333;
  }
  .date { 
    margin-left: 20px;
    font-size: 14px;
    color: #666;
  }
`;

const ProfileContainer = styled.div`
  display: flex;
  padding: 10px;
`;

const NameEmailContainer = styled.div`
  float: left;
  margin: 0 15px;
`;

const SecondaryEmailContainer = styled.div`
  color: #666;
  font-size: 12px;
  font-weight: 400;
`;

const SpacedPTag = styled.p`
  letter-spacing: .1px;
`;

const FlexDiv = styled.div`
  display: flex;
`;

export class TeamSlideDialog extends Component {
    state = {
        isLoading: true,
        isLoadingUsedPresentations: true,
        usedPresentationsSort: { field: "name", reverse: false },
        libraryItem: { createdBy: {}, createdAt: "", modifiedBy: {}, modifiedAt: "" },
        usedPresentations: [],
        backboneLibraryItem: {}
    };

    async componentDidMount() {
        const { libraryItemId } = this.props;
        const defaultTeam = ds.teams.defaultTeamForOrg(app.appState.orgId);
        let backboneLibraryItem = defaultTeam.libraryItems.get(libraryItemId);
        //in case the library item is not loaded and added to the default team yet load the library item
        if (!backboneLibraryItem) {
            backboneLibraryItem = new LibraryItem({ id: libraryItemId });
            await backboneLibraryItem.load();
        }

        const updatedLib = await this.sanitizeLibraryResponse(backboneLibraryItem);
        this.setState({ libraryItem: updatedLib, isLoading: false, backboneLibraryItem });
        this.loadSlideUsedContainer(Object.keys(backboneLibraryItem.attributes.usedInPresentations || {}), backboneLibraryItem);
    }

    componentWillUnmount() {
        this.props.callback && this.props.callback();
    }

    async loadSlideUsedContainer(presentationIds, libraryItem) {
        //get all presentations
        let presentations = [];
        if (presentationIds.length) {
            const response = await Api.libraryItems.get({
                type: "presentations",
                libraryItemId: libraryItem.get("id"),
                teamId: libraryItem.get("teamId")
            });
            presentations = response.body;
        }

        for (let presentation of presentations) {
            // presentationlibrarylist expects a getThumbnailUrl function
            presentation.getThumbnailUrl = () => presentation.imageURL;
        }

        this.setState({ isLoadingUsedPresentations: false, usedPresentations: presentations });
    }

    async sanitizeLibraryResponse(libraryItem) {
        const response = Object.assign({}, libraryItem.attributes);
        response.usedByCount = Object.keys(libraryItem.attributes.usedByUsers || {}).length;
        response.ratedByCount = Object.keys(libraryItem.attributes.ratedByUsers || {}).length;
        response.presentationCount = Object.keys(libraryItem.attributes.usedInPresentations || {}).length;
        response.tagsList = Object.keys(libraryItem.attributes.tags || {});
        const [createdUser, modifiedUser] = await Promise.all([
            getUserProfile(libraryItem.attributes.createdBy),
            libraryItem.attributes.modifiedBy && getUserProfile(libraryItem.attributes.modifiedBy)
        ]);

        response.createdBy = createdUser;
        response.modifiedBy = modifiedUser;
        return response;
    }

    handleSortUsedPresentations = sort => {
        let presentations = this.state.usedPresentations;

        let sortedData;
        sortedData = _.sortBy(presentations, o => {
            if (typeof o[sort.field] == "string") {
                return o[sort.field].toLowerCase();
            } else {
                return o[sort.field];
            }
        });

        if (sort.reverse) {
            sortedData = sortedData.reverse();
        }

        this.setState({ usedPresentationsSort: sort, usedPresentations: sortedData });
    }

    renderName(user) {
        if (user.displayName) {
            return (
                <Fragment>
                    <span className="fullName">{user.displayName}</span>
                </Fragment>
            );
        } else {
            return <span className="fullName">{user.email}</span>;
        }
    }

    handleEditSlide = async () => {
        const { backboneLibraryItem } = this.state;

        this.props.closeDialog();

        ShowDialog(EditSharedSlideDialog, {
            slideId: backboneLibraryItem.get("contentId"),
            openFromLibrary: this.props.openFromLibrary
        });
    }

    handleDeleteSlide = () => {
        const { backboneLibraryItem, usedPresentations } = this.state;

        if (usedPresentations.length > 0) {
            ShowMessageDialog({
                title: "Sorry, you can't delete a Team Slide that is being used in presentations.",
                message: "If you want to prevent this Team Slide from being used in any additional presentations, you can disable the slide."
            });
            return;
        }

        ShowConfirmationDialog({
            title: "Are you sure you want to delete this Team Slide?",
            message: "Deleting a Team Slide permanently removes it from your Team Slides library and prevents it from being used in any future presentations.",
            buttonOptions: { cancelButtonVariant: "outlined", acceptButtonColor: "red" },
            okButtonLabel: "PERMANENTLY DELETE TEAM SLIDE",
            acceptCallback: async () => {
                this.setState(prevState => {
                    return {
                        ...prevState,
                        isLoading: true
                    };
                });
                try {
                    await backboneLibraryItem.destroy();
                    const props = {
                        slide_id: backboneLibraryItem.get("contentId"),
                    };
                    trackActivity("SharedSlideLibrary", "SlideDeleted", null, null, props);
                    this.props.closeDialog();
                } catch (err) {
                    log.error(err);
                    ShowErrorDialog({
                        error: "An error occurred while deleting the Team Slide.",
                        message: (
                            <Fragment>
                                <p>
                                    <strong>Error:</strong> {err.message}
                                </p>
                                <p>We apologize for the inconvenience. Please contact us at support@beautiful.ai.</p>
                            </Fragment>
                        )
                    });
                }
            }
        });
    }

    handleDisableSlideToggle = isDisabled => {
        const { backboneLibraryItem } = this.state;

        if (!isDisabled) {
            ShowDialog(ConfirmationCheckboxDialog, {
                title: "Are you sure you want to hide this Team Slide?",
                message: "Hiding a Team Slide prevents it from being used in future presentations.",
                okButtonLabel: "OK",
                acceptCallback: () => {
                    this.setState(prevState => {
                        return {
                            ...prevState,
                            libraryItem:
                            {
                                ...prevState.libraryItem,
                                isDisabled: !isDisabled
                            }
                        };
                    }, () => {
                        backboneLibraryItem.update({ isDisabled: !isDisabled });
                        const props = {
                            slide_id: backboneLibraryItem.get("contentId"),
                        };
                        trackActivity("SharedSlideLibrary", "SlideDisabled", null, null, props);
                    });
                }
            });
            return;
        }
        this.setState(prevState => {
            return {
                ...prevState,
                libraryItem:
                {
                    ...prevState.libraryItem,
                    isDisabled: !isDisabled
                }
            };
        }, () => {
            backboneLibraryItem.update({ isDisabled: !isDisabled });
        });
    }

    handleTextChange(text, type) {
        this.setState(prevState => {
            return {
                ...prevState,
                libraryItem: {
                    ...prevState.libraryItem,
                    [type]: text
                }
            };
        });
    }

    handleTextBlur(text, type) {
        if (type !== "description" && type !== "name") {
            return;
        }
        const { backboneLibraryItem } = this.state;
        backboneLibraryItem.update({ [type]: text });
    }

    handleRemoveTag = inputTag => {
        const { backboneLibraryItem } = this.state;
        this.setState(prevState => {
            return {
                ...prevState,
                libraryItem: {
                    ...prevState.libraryItem,
                    tagsList: prevState.libraryItem.tagsList.filter(tag => tag !== inputTag)
                }
            };
        }, () => {
            backboneLibraryItem.update({ tags: { [inputTag]: null } });
        });
    }

    handleAddTag = () => {
        const { backboneLibraryItem, libraryItem } = this.state;

        ShowDialog(AddLibraryTagsDialog, {
            activeTags: (libraryItem.tagsList || []).map(_.trim),
            organizationId: this.props.organizationId,
            acceptCallback: newTags => {
                this.setState(prevState => {
                    const tagsWithoutDuplicates = [...new Set(prevState.libraryItem.tagsList.concat(newTags))];
                    return {
                        ...prevState,
                        libraryItem: {
                            ...prevState.libraryItem,
                            tagsList: tagsWithoutDuplicates
                        }
                    };
                }, () => {
                    newTags.map(newTag => backboneLibraryItem.update({ tags: { [newTag]: true } }));
                });
            },
        });
    }

    render() {
        const { isLoading, isLoadingUsedPresentations, usedPresentations, usedPresentationsSort, isSlideUsedLoading, libraryItem } = this.state;
        const { createdAt, modifiedAt, modifiedBy, createdBy, isDisabled } = libraryItem;
        const tagsList = caseInsensitiveSort([...(libraryItem.tagsList || [])], _.trim);

        return (
            <BeautifulDialog closeDialog={this.props.closeDialog} maxWidth="lg" closeButton>
                <UIPane style={{ overflow: "hidden" }}>
                    <UIPaneHeader>Team Slide Settings</UIPaneHeader>
                    <ScrollBox id="shared-slide-properties-content">
                        <UIPaneContents style={{ minHeight: 200 }}>
                            <Loadable isLoading={isLoading}>
                                <Section>
                                    <Gap10 />
                                    <FlexBox top left>
                                        <SlideThumbnailContainer>
                                            <SlideThumbnail slideId={libraryItem.contentId} highQuality />
                                            {(app.mainView?.editorView == null || !app.mainView.editorView.isSlideEditor) &&
                                                <div className="edit-message">
                                                    <BlueButton onClick={this.handleEditSlide}>Edit Slide...</BlueButton>
                                                </div>
                                            }
                                        </SlideThumbnailContainer>
                                        <Gap30 />
                                        <FlexBox column top left width={500}>
                                            <TextField
                                                id="library-name"
                                                autoFocus
                                                label="Name"
                                                fullWidth
                                                value={libraryItem.name || ""}
                                                onChange={event => this.handleTextChange(event.target.value, "name")}
                                                onBlur={event => this.handleTextBlur(event.target.value, "name")}
                                            />
                                            <Gap30 />

                                            <UserInfo>
                                                <label>Created by</label>
                                                <Avatar url={createdBy.photoURL} />
                                                <div className="name">{this.renderName(createdBy)}</div>
                                                <div className="date">{moment.utc(createdAt).local().format("LL")}</div>
                                            </UserInfo>
                                            <Gap20 />
                                            {modifiedBy &&
                                                <UserInfo>
                                                    <label>Modified by</label>
                                                    <Avatar url={modifiedBy.photoURL} />
                                                    <div className="name">{this.renderName(modifiedBy)}</div>
                                                    <div className="date">{moment.utc(modifiedAt).local().format("LL")}</div>
                                                </UserInfo>
                                            }

                                            <Gap20 />

                                            <StatsContainer>
                                                <FlexBox left middle>
                                                    <Icon>star</Icon>
                                                    {libraryItem.ratedByCount} {"like".pluralize(libraryItem.ratedByCount != 1)}
                                                </FlexBox>

                                                <FlexBox left middle>
                                                    <Icon>person</Icon>
                                                    Used
                                                    by {libraryItem.usedByCount} {libraryItem.usedByCount == 1 ? "person" : "people"}
                                                </FlexBox>

                                                <FlexBox left middle>
                                                    <Icon>cloud_download</Icon>
                                                    Used
                                                    in {libraryItem.presentationCount} {"presentation".pluralize(libraryItem.presentationCount !== 1)}
                                                </FlexBox>
                                            </StatsContainer>

                                            <Gap20 />
                                            <RedSwitch
                                                id="hideSlideSwitch"
                                                checked={isDisabled}
                                                onChange={() => this.handleDisableSlideToggle(isDisabled)}
                                                value="disableSlide"
                                                label="Hide This Slide"
                                            />

                                        </FlexBox>
                                    </FlexBox>
                                    <Gap20 />
                                    <TextField multiline
                                        fullWidth
                                        value={libraryItem.description}
                                        placeholder="Add a description or instructions for this slide"
                                        variant="outlined"
                                        onChange={event => this.handleTextChange(event.target.value, "description")}
                                        inputProps={{
                                            onBlur: event => this.handleTextBlur(event.target.value, "description")
                                        }}
                                    />

                                </Section>
                                <Section>
                                    <FlexBox left middle fillWidth>
                                        <div className="section-title">Tags</div>
                                        <Gap20 />
                                        <TagsList tags={tagsList} onRemove={this.handleRemoveTag}
                                            onClick={this.handleAddTag} />
                                    </FlexBox>
                                </Section>
                                <Section title="Where is this slide used">
                                    <Loadable isLoading={isLoadingUsedPresentations}>
                                        {(usedPresentations.length > 0) &&
                                            <PresentationLibraryList items={usedPresentations}
                                                sort={usedPresentationsSort}
                                                onSort={this.handleSortUsedPresentations}
                                                readOnly />
                                        }
                                        {(usedPresentations.length == 0) &&
                                            <label>This team slide is not used in any presentations.</label>
                                        }
                                    </Loadable>
                                </Section>
                                {/*<Section id="manage-shared-slide-container">*/}
                                {/*    <FlexBox left>*/}
                                {/*        <RedSwitch*/}
                                {/*            checked={isDisabled}*/}
                                {/*            onChange={() => this.handleDisableSlideToggle(isDisabled)}*/}
                                {/*            value="disableSlide"*/}
                                {/*            label="Hide Team Slide"*/}
                                {/*        />*/}
                                {/*        <FlexSpacer/>*/}
                                {/*        <ScaryButton onClick={this.handleDeleteSlide}>*/}
                                {/*            Delete Team Slide*/}
                                {/*        </ScaryButton>*/}
                                {/*    </FlexBox>*/}

                                {/*</Section>*/}
                            </Loadable>
                        </UIPaneContents>
                    </ScrollBox>
                </UIPane>
            </BeautifulDialog>
        );
    }
}

const TagList = styled.div`
  //margin-bottom: -10px;
  width: 100%;
  .MuiChip-root {
    margin-right: 10px;
    margin-bottom: 5px;
    margin-top: 5px;
  }
`;

export function TagsList({ tags, onRemove, onClick, classes }) {
    return (
        <TagList>
            {tags.map((tag, i) => {
                return (<Chip
                    clickable={true}
                    key={i}
                    color="default"
                    label={tag}
                    onDelete={() => onRemove(tag)}
                    deleteIcon={<Icon fontSize="small">close</Icon>}
                />);
            })}
            <Chip
                icon={<Icon>add_circle</Icon>}
                color="primary"
                label={"ADD TAG"}
                onClick={onClick}
                style={{ color: "white", fontWeight: 600 }}
            />
        </TagList>
    );
}

const EditorFrame = styled.div`
  width: 100%;
  height: calc(100vh - 160px);
  background: #4b4e55;
  position: relative;
`;

export class EditSharedSlideDialog extends Component {
    constructor() {
        super();

        this.editorRef = React.createRef();

        this.state = {
            isLoading: true
        };

        this.shouldRenderMainViewOnUnmount = false;
    }

    async componentDidMount() {
        let { slideId } = this.props;

        if (app.mainView.editorView) {
            this.shouldRenderMainViewOnUnmount = true;
            ds.selection.element = null;
            app.mainView.editorView.remove();
            app.mainView.$menuBar.remove();
        }

        const defaultTeam = ds.teams.defaultTeamForOrg(app.appState.orgId);
        const teamTheme = ds.sharedThemes.findWhere({ id: defaultTeam.get("sharedThemeId") });

        this.dummyPresentation = new Presentation({
            name: "Team Slide",
            isSlideEditor: true,
            userId: app.user.id,
            orgId: app.appState.orgId,
            themeId: teamTheme.id,
            sharedThemeId: teamTheme.id,
            isDummy: true
        }, { disconnected: true, userId: app.user.id });
        this.dummyPresentation.permissions.write = true;
        this.dummyPresentation.permissions.read = true;

        if (slideId) {
            let slide = new Slide({ id: slideId }, {
                userId: app.user.id,
                presentation: this.dummyPresentation
            });
            await slide.load();

            // detach adapter so changes are not saved automatcally until we call slide.saveChanges()
            slide.detachAdapter();

            await this.dummyPresentation.batchShareSlides([slide], { insertIndex: 0, skipUndo: true });
        }

        await ds.presentations.add(this.dummyPresentation, { loadModels: false });

        ds.selection.presentation = this.dummyPresentation;
        this.editorView = new EditorView({ disableCollaborationLocks: true });
        app.mainView.editorView = this.editorView;
        $(this.editorRef.current).append(this.editorView.render().$el);

        const undoRedo = new UndoRedo();
        undoRedo.$el.addClass("team-slide-editor");
        this.editorView.$el.addEl(undoRedo.render());

        await app.themeManager.loadTheme(this.dummyPresentation);

        this.editorView.$el.animate({ opacity: 1 });

        if (!slideId) {
            await ShowDialogAsync(AddSlideContainer, {
                forTeamSlide: true,
            });
            this.editorView.resize(false);
        } else {
            this.editorView.showEditorMenuBar();
        }

        await this.editorView.loadPresentation(0);
        $(this.editorRef.current).spinner(false);
    }

    closeDialog() {
        if (this.editorView) {
            $(".dropdown_menu, .dialog-container").remove();
            this.editorView.remove();
            this.dummyPresentation.destroy();
            app.mainView.editorView = null;
        }
        if (this.props.openFromLibrary) {
            app.appState.setLibraryLocation({ type: "team-resources", pane: "slides" });
        }
        if (this.shouldRenderMainViewOnUnmount) {
            app.mainView.render();
        }
        this.props.closeDialog();
    }

    handleCancelChanges = () => {
        this.closeDialog();
    }

    handleSaveChanges = async () => {
        ds.selection.element = null;
        if (this.props.slideId) {
            ShowConfirmationDialog({
                title: "Are you sure you want to save this Team Slide?",
                message: "Changes will be applied to all presentations that use this slide.",
                acceptCallback: () => {
                    const slide = ds.selection.slide;
                    ds.selection.element = null;

                    slide.saveChanges().then(() => {
                        Thumbnails.getSignedUrlAndLoad(slide.id, slide.get("modifiedAt"));

                        const props = {
                            slide_id: slide.id,
                            template_name: slide.get("template_id"),
                        };
                        trackActivity("SharedSlideLibrary", "SlideContentEdited", null, null, props, { audit: true });

                        this.closeDialog();
                    });
                }
            });
        } else {
            this.editorView.setEditorLockState(false);
            await ShowDialogAsync(CreateSharedSlideDialog, { slide: ds.selection.slide, presentation: null });
            this.closeDialog();
        }
    }

    render() {
        let { slideId } = this.props;
        let { isLoading } = this.state;

        let url = "/slide/" + slideId;
        return (
            <BeautifulDialog fullScreen closeDialog={this.handleCancelChanges}>
                <DialogTitle>You are editing a Team Slide</DialogTitle>
                <DialogContent style={{ overflow: "hidden", padding: "0px 34px" }}>
                    {/*<iframe src={url} width="100%" height="100%" style={{ border: "none" }}/>*/}
                    {/*<Loadable isLoading={isLoading}>*/}
                    <EditorFrame ref={this.editorRef}></EditorFrame>
                    {/*</Loadable>*/}
                </DialogContent>
                <DialogActions>
                    <Button onClick={this.handleCancelChanges}>Cancel</Button>
                    <Button onClick={this.handleSaveChanges} color="primary">Save Changes</Button>
                </DialogActions>
            </BeautifulDialog>
        );
    }
}

export class LockedSharedSlideDialog extends Component {
    state = {
        isLoading: true,
        firstHalfOfMembers: [],
        secondHalfOfMembers: []
    }

    async componentDidMount() {
        const { organizationId } = this.props;
        const defaultTeam = ds.teams.defaultTeamForOrg(organizationId);
        let ownersAndLibrariansIds = [];

        for (let [memberId, memberData] of Object.entries(defaultTeam.get("members"))) {
            if (memberData.role === TEAM_USER_ROLES.OWNER || memberData.role === TEAM_USER_ROLES.LIBRARIAN) {
                ownersAndLibrariansIds.push(memberId);
            }
        }

        const ownersAndLibrariansProfiles = await Promise.all(ownersAndLibrariansIds.map(memberId => getUserProfile(memberId)));
        const halfwayIndex = Math.ceil(ownersAndLibrariansProfiles.length / 2);

        const firstHalfOfMembers = ownersAndLibrariansProfiles.filter((member, index) => index < halfwayIndex);
        const secondHalfOfMembers = ownersAndLibrariansProfiles.filter((member, index) => index >= halfwayIndex);

        this.setState({ firstHalfOfMembers, secondHalfOfMembers, isLoading: false });
    }

    render() {
        const { isLoading, firstHalfOfMembers, secondHalfOfMembers } = this.state;

        return (
            <BeautifulDialog closeDialog={this.props.closeDialog} >
                <DialogTitle>Sorry, you don't have permission to edit this Team Slide.</DialogTitle>
                <DialogContent>
                    <Loadable isLoading={isLoading}>
                        <SpacedPTag>This is a Team Slide and it's content is only editable by Owners and Librarians in your team. These are the members who have editing permissions.</SpacedPTag>
                        <FlexDiv>
                            <div>
                                {

                                    firstHalfOfMembers.map(user => {
                                        return (
                                            <ProfileContainer key={user.uid}>
                                                <UserProfile
                                                    key={user.uid}
                                                    profile={user}
                                                />
                                            </ProfileContainer>
                                        );
                                    })
                                }
                            </div>
                            <div>
                                {
                                    secondHalfOfMembers.map(user => {
                                        return (
                                            <ProfileContainer key={user.uid}>
                                                <UserProfile
                                                    key={user.uid}
                                                    profile={user}
                                                />
                                            </ProfileContainer>
                                        );
                                    })
                                }
                            </div>
                        </FlexDiv>
                    </Loadable>
                </DialogContent>
                <DialogActions>
                    <Button color="primary" onClick={this.props.closeDialog} >
                        Got It
                    </Button>
                </DialogActions>
            </BeautifulDialog>
        );
    }
}
